import { useRef, useEffect } from "react";

const AutoResizingInput = ({ setMessage, message, handleKeyDown }) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "30px";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [message]);

  return (
    <textarea
      onKeyDown={handleKeyDown}
      ref={textareaRef}
      value={message}
      className="chat-input__text"
      onChange={(e) => setMessage(e.target.value)}
      style={{
        width: "100%",
        minHeight: "20px",
        resize: "none",
        wordBreak: "break-word",
        overflowWrap: "anywhere",
        whiteSpace: "pre-wrap",
      }}
      placeholder="Напишите сообщение..."
    />
  );
};

export default AutoResizingInput;
